import axios from 'axios';
import urls from './WebUrls';


class GisApiServices {
    mistDetails = (info, config) => {
        const data = {
            ulb_cd: info?.selectedUlb,
            Relation_id: info?.relationIds
        };
        return axios.post(urls.getMisData, data, config);
    }

    loginGis = (values) => {
        const data = {
            UserId: values?.userid,
            password: values?.password
        };

        return axios.post(
            urls.gisLogin,
            data
        );
    };

    newUserCreate = (values, config) => {
        return axios.post(urls.gisNewUser, values, config)
    }

    userRoleCreate = (values, config) => {
        return axios.post(urls.createUserRole, values, config)
    }

    getUlbDistrict = (values, config) => {
        return axios.post(urls.getDisUlb, values, config)
    }

    getDepartDesignation = (values, config) => {
        return axios.post(urls.getDepartment, values, config)
    }
    userRoleDetails = (values, config) => {
        return axios.post(urls.GetUserRoleDetails, values, config)
    }
    userCreatePermission = (values, config) => {
        return axios.post(urls.createUserPermission, values, config)
    }
    userDetails = (values, config) => {
        return axios.post(urls.getUserDetails, values, config)
    }
    createLog = (values, config) => {
        return axios.post(urls.logCreate, values, config)
    }
    moduleAccess = (values, config) => {
        return axios.post(urls.getModuleAccess, values, config)
    }
    userPermissions = (values, config) => {
        return axios.post(urls.getUserPermission, values, config)
    }

    userPermissionsEdit = (values, config) => {
        return axios.post(urls.getUserPermissionEdit, values, config)
    }
    getSearchUsers = (values, config) => {
        return axios.post(urls.searchUsers, values, config)
    }
    userEditDetails = (values, config) => {
        return axios.post(urls.editUser, values, config)
    }
    utilityDashboard = (values, config) => {
        return axios.post(urls.utilityDashboard, values, config)
    }
    getuploadedULB = (values, config) => {
        return axios.post(urls.getuploadedULB, values, config)
    }
    ENPPropertyDetails = (values, config) => {
        return axios.post(urls.ENPPropertyDetails, values, config)
    }
    TotalULB = (values, config) => {
        return axios.post(urls.TotalULB, values, config)
    }
    TotalWard = (values, config) => {
        return axios.post(urls.TotalWard, values, config)
    }
    TotalProperties = (values, config) => {
        return axios.post(urls.TotalProperties, values, config)
    }
    GetuploadedWard = (values, config) => {
        return axios.post(urls.GetuploadedWard, values, config)
    }
    GetuploadedULB = (values, config) => {
        return axios.post(urls.GetuploadedULB, values, config)
    }
    WaterSupplyULB = (values, config) => {
        return axios.post(urls.WaterSupplyULB, values, config)
    }
    intakeWall = (values, config) => {
        return axios.post(urls.intakeWall, values, config)
    }
    rowWaterPm = (values, config) => {
        return axios.post(urls.rowWaterPm, values, config)
    }
    waterTreatmentPlant = (values, config) => {
        return axios.post(urls.waterTreatmentPlant, values, config)
    }
    clearWaterPumpingMain = (values, config) => {
        return axios.post(urls.clearWaterPumpingMain, values, config)
    }
    totalOverHeadTank = (values, config) => {
        return axios.post(urls.totalOverHeadTank, values, config)
    }
    distributionPipeline = (values, config) => {
        return axios.post(urls.distributionPipeline, values, config)
    }
    waterJunction = (values, config) => {
        return axios.post(urls.waterJunction, values, config)
    }
    sewerNetworkulb = (values, config) => {
        return axios.post(urls.sewerNetworkulb, values, config)
    }
    sewerNetwork = (values, config) => {
        return axios.post(urls.sewerNetwork, values, config)
    }
    sewerTreatmentPlant = (values, config) => {
        return axios.post(urls.sewerTreatmentPlant, values, config)
    }
    seweragePumpingStation = (values, config) => {
        return axios.post(urls.seweragePumpingStation, values, config)
    }
    intermediatePumpingStation = (values, config) => {
        return axios.post(urls.intermediatePumpingStation, values, config)
    }
    totalManholes = (values, config) => {
        return axios.post(urls.totalManholes, values, config)
    }
    population = (values, config) => {
        return axios.post(urls.population, values, config)
    }

    roadNetWorklength = (values, config) => {
        return axios.post(urls.roadNetWorklength, values, config)
    }
    roadNetWork = (values, config) => {
        return axios.post(urls.roadNetWork, values, config)
    }
    RoadNetWorkULB = (values, config) => {
        return axios.post(urls.RoadNetWorkULB, values, config)
    }

    totalRiver = (values, config) => {
        return axios.post(urls.totalRiver, values, config)
    }
    waterbody = (values, config) => {
        return axios.post(urls.waterbody, values, config)
    }
    totalParks = (values, config) => {
        return axios.post(urls.totalParks, values, config)
    }
    forestArea = (values, config) => {
        return axios.post(urls.forestArea, values, config)
    }

    GetLogsByUser = (values, config) => {
        return axios.post(urls.GetLogsByUser, values, config)
    }
    DeleteUserDetails = (values, config) => {
        return axios.post(urls.DeleteUserDetails, values, config)
    }
    DeleteUserRole = (values, config) => {
        return axios.post(urls.DeleteUserRole, values, config)
    }
    EditUserRole = (values, config) => {
        return axios.post(urls.EditUserRole, values, config)
    }

    GetUserVisitCount = (config) => {
        return axios.get(urls.GetUserVisitCount, config)
    }
}
export default new GisApiServices();